import styled from 'styled-components';
import Link from 'next/link';
import { ReactNode } from 'react';
import UserLink from 'src/modules/shared/links/userLink';
import Roles from 'src/components/roles';
import i18n from 'src/utils/translate';
import { userHasRole } from 'src/utils/context';
import { textSmall, textLinkPrimarySmall } from 'styles-js/mixins/typography';
import { useSelector } from 'src/store/store';
import { Role, EditAuthor } from 'src/constants/types';
import Icon from 'src/components/icon';
type Props = {
  editAuthor: EditAuthor;
};
export default function LastEditedBy({
  editAuthor
}: Props) {
  const {
    currentUser,
    currentCommunity
  } = useSelector(({
    context
  }) => context);
  const isEditAuthorPAM = userHasRole(editAuthor, [Role.Partner, Role.Administrator, Role.Moderator]);
  const isEditAuthorHU = userHasRole(editAuthor, [Role.HealthUnlocked]);
  const isUserPAM = userHasRole(currentUser, [Role.Partner, Role.Administrator, Role.Moderator]);
  const isUserHU = userHasRole(currentUser, [Role.HealthUnlocked]);
  if (!currentUser) return null;
  if (isEditAuthorHU && !isUserHU) {
    return <EditedBy>{i18n.t('HealthUnlocked staff')}</EditedBy>;
  } else if (isEditAuthorPAM && !isUserHU && !isUserPAM) {
    return <EditedBy><Link href={`/${currentCommunity?.slug}/about#whoweare`}>{i18n.t('moderation team')}</Link></EditedBy>;
  } else {
    return <EditedBy>
        <UserLink user={editAuthor} />
        {' '}
        {editAuthor?.roles?.length > 0 && <Roles roles={editAuthor.roles} />}
      </EditedBy>;
  }
}
function EditedBy({
  children
}: {
  children: ReactNode;
}) {
  return <LastEdited data-sentry-element="LastEdited" data-sentry-component="EditedBy" data-sentry-source-file="lastEditedBy.tsx">
      <Icon icon="pencil" data-sentry-element="Icon" data-sentry-source-file="lastEditedBy.tsx" />
      {' '}
      {i18n.t('Last edited by')}
      {' '}
      {children}
    </LastEdited>;
}
const LastEdited = styled.div`
  ${textSmall};
  color: ${props => props.theme.colorTextLight};
  a {
    ${textLinkPrimarySmall};
  }
`;